import Axios from 'axios'
import vue from 'vue'
import { baseUrl } from '@/config/env'

const headers = {
  'Content-Type': 'application/json'
}
const http = Axios.create({
  withCredentials: false,
  baseURL: baseUrl,
})
const magObj = {
  hasMeg: false,
  error(message) {
    if (this.hasMeg) {
      return
    }
    this.hasMeg = true
    const onClose = () => {
      this.hasMeg = false
    }
    vue.$message.error({
      message,
      onClose
    })
  }
}

export const requests = Axios.create({
  //基础路径,发请求URL携带api【发现:真实服务器接口都携带/api】
  baseURL: "api/",
  //超时的设置
  // timeout: 10000*60,
});

requests.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) { config.headers = { ...headers, Authorization: token } }
  return config
});

//响应拦截器：请求数据返回会执行
requests.interceptors.response.use(
  response  => {
    return Promise.resolve(response.data)
    },
    
    error => {
      // 处理错误的响应
      if (error.response.data.code.toString() === '401000') {
        next("/login")
      }
      return Promise.resolve(error.response.data);
    }
);

// 仅供产能配置使用，保留旧请求的响应行为；HTTP/网络失败保持 reject。
export const productionRequests = Axios.create({ baseURL: requests.defaults.baseURL });
productionRequests.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  config.headers = { ...headers, ...(token ? { Authorization: token } : {}) };
  return config;
});
productionRequests.interceptors.response.use(response => response.data);
